module.exports = __webpack_public_path__ + "static/media/leisure.690a8cf1.svg";